import createApiClient from "./api";

const client = createApiClient();

const downloadApi = createApiClient(false, true);

const user = JSON.parse(sessionStorage.getItem("user"));

export const api = {
  createLearningPath: ({ org_id, payload }) =>
    client
      .post(`admin/learning-paths`, payload)
      .then(({ data }) => data),

  editLearningPath: ({ org_id, payload, id }) =>
    client
      .patch(`admin/learning-paths/${id}`, payload)
      .then(({ data }) => data),

  getLearningPath: ({ org_id, search, perPage, currentPage, status = '', sortBy = '', order = '' }) =>
    client
      .get(
        `admin/learning-paths?page=${currentPage}&perPage=${perPage}${search ? `&search=${search}` : ""
        }${status ? `&status=${status}` : ""}${sortBy ? `&sortBy=${sortBy}` : ""}${order ? `&order=${order}` : ""}`
      )
      .then(({ data }) => data),

  getIndividualLearningPath: ({ org_id, id }) =>
    client
      .get(
        `/admin/learning-paths/${id}`
      )
      .then(({ data }) => data),

  getLearningPathLearners: ({ learningPathId, page = 1, perPage = 1000, search = '' }) =>
    client
      .get(
        `/admin/learning-paths/${learningPathId}/learners?page=${page}&perPage=${perPage}${search ? `&search=${search}` : ''}`
      )
      .then(({ data }) => data),

  getLearningPathLearnerDetail: ({ learnerId }) =>
    client
      .get(`/admin/learning-paths/learners/${learnerId}`)
      .then(({ data }) => data),

  getCourses: ({ search }) =>
    client.get(`admin/courses?search=${search}`).then(({ data }) => data),

  getCohorts: ({ org_id, search }) =>
    client
      .get(`admin/org/${org_id}/cohorts?search=${search}`)
      .then(({ data }) => data),

  getSinglePath: ({ org_id, journey_id }) =>
    client
      .get(`admin/learning-paths/${journey_id}`)
      .then(({ data }) => data),

  addCourses: ({ learningPathId, payload }) =>
    client
      .post(
        `/admin/learning-paths/${learningPathId}/assign-courses`,
        payload
      )
      .then(({ data }) => data),

  unassignCoursesFromLearningPath: ({ learningPathId, payload }) =>
    client
      .post(
        `/admin/learning-paths/${learningPathId}/unassign-courses`,
        payload
      )
      .then(({ data }) => data),

  addPaths: ({ org_id, journey_id, payload }) =>
    client
      .post(
        `/admin/org/${org_id}/journies/${journey_id}/learning-paths`,
        payload
      )
      .then(({ data }) => data),

  assignPrerequisites: ({ org_id, journey_id, payload }) =>
    client
      .post(
        `/admin/org/${org_id}/journies/${journey_id}/assign-prerequisites`,
        payload
      )
      .then(({ data }) => data),

  assignSurvey: ({ org_id, response_id, actionPlanId }) =>
    client
      .post(
        `/admin/org/${org_id}/action-plans/${actionPlanId}/survey/${response_id}`
      )
      .then(({ data }) => data),

  getCohort: ({ id, search, perPage, currentPage }) =>
    client
      .get(
        `admin/org/${id}/cohorts?perPage=${perPage}${search ? `&search=${search}` : ""
        }&page=${currentPage}`
      )
      .then(({ data }) => data),

  getCohortActionPlan: ({ id, search, perPage, currentPage, cohortId }) =>
    client
      .get(
        `admin/org/${id}/action-plans/cohorts/${cohortId}?perPage=${perPage}${search ? `&search=${search}` : ""
        }&page=${currentPage}`
      )
      .then(({ data }) => data),

  getOrgSurveys: ({ id }) =>
    client
      .get(`admin/org/${id}/surveys`).then(({ data }) => data),

  getSurveyResponse: ({ id, actionPlanId, cohortId, responseId, surveyId }) =>
    client
      .get(`/admin/org/${id}/action-plans/${actionPlanId}/cohorts/${cohortId}/surveys/${surveyId}/responses/${responseId}`)
      .then(({ data }) => data),
  getCohortActionPlanLearners: ({ id, search, perPage, currentPage, cohortId, actionPlanId }) =>
    client
      .get(
        `admin/org/${id}/action-plans/${actionPlanId}/cohorts/${cohortId}/learners?perPage=${perPage}${search ? `&search=${search}` : ""
        }&page=${currentPage}`
      )
      .then(({ data }) => data),

  getCohortUsers: ({ id, search, perPage, currentPage, cohortId, filter, download }) =>
    client
      .get(
        `admin/org/${id}/cohorts/${cohortId}/learners/courses?perPage=${perPage}${search ? `&search=${search}` : ""
        }&page=${currentPage}${filter ? `&status=${filter}` : ""
        }`
      )
      .then(({ data }) => data),

  downloadCohortUsers: ({ id, cohortId, filter, download }) =>
    downloadApi
      .get(
        `admin/org/${id}/cohorts/${cohortId}/learners/courses?page=1${filter ? `&status=${filter}` : ""
        }${download ? `&download=${download}` : ""
        }`
      )
      .then(({ data }) => data),

  createCohort: (payload) =>
    client
      .post(`admin/org/${payload?.id}/cohorts`, payload?.data)
      .then(({ data }) => data),

  updateCohort: (payload) =>
    client
      .patch(`admin/org/${payload?.id}/cohorts/${payload?.cohortId}`, payload?.data)
      .then(({ data }) => data),

  addLearnersToCohort: (payload) =>
    client
      .post(
        `admin/org/${payload?.id}/cohorts/${payload?.cohortId}/assign-participants`,
        payload?.data
      )
      .then(({ data }) => data),

  assignCohorts: ({ org_id, journey_id, payload }) =>
    client
      .post(
        `/admin/org/${org_id}/journies/${journey_id}/assign-cohorts`,
        payload
      )
      .then(({ data }) => data),

  addMultiLanguageName: (payload) =>
    client
      .patch(`admin/org/${payload?.id}/cohorts/${payload?.cohortId}/name`, payload?.data)
      .then(({ data }) => data),

  getLearningPathSummary: (id) => client.get(`/admin/learning-paths/${id}/learners/summary`),
  getExams: (id) => client.get(`/admin/org/${id}/exams`)
};

